import React, { FormEvent, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { LoginSteps } from '../Login'
import useAssociate from 'src/hooks/useAssociate'
import { AssociateError } from 'src/util/associate'
import Loading from 'src/components/Loading/Loading'

type Status = Extract<LoginSteps, 'missing-secret' | 'invalid-secret'>

const fields: Record<Status, {title: string, description: string}> = {
  'missing-secret': {
    description: 'login.remind',
    title: 'login.see-email'
  },
  'invalid-secret': {
    description: 'login.re-pair-client-info',
    title: 'login.re-pair-client-no-association'
  }
}

interface SecretProps {
  handleStatus: (step: LoginSteps) => void
  status: Status
  userId: string | null
}

export default function Secret ({
  handleStatus,
  status,
  userId
}: SecretProps) {

  const [code, setCode] = useState<string>('')
  const [error, setError] = useState<string>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { associateUser } = useAssociate()
  const intl = useIntl()

  const handleContinue = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setLoading(true)
      await associateUser(userId, code)
    } catch (err) {
      setLoading(false)
      if (err instanceof AssociateError) {
        setError('two-factor.code')
      } else if (err.message === 'Wrong role') {
        setError('login.error-403')
      } else {
        setError('two-factor.code-error')
        console.warn(err)
      }
    }
  }

  if (loading) return <Loading />
  const canRetry = !error || error !== 'login.error-403'

  return (
    <form onSubmit={handleContinue}>
      {canRetry && (
        <>
          <p className="secret-title">
            <FormattedMessage id={fields[status].title} />
          </p>
          <label className="code">
            <span className="icon icon-lock" />
            <input
              required
              type="text"
              placeholder={intl.formatMessage({ id: 'code' })}
              value={code}
              onChange={({ target }) => setCode(target.value)}
            />
          </label>
        </>
      )}
      {!error
        ? <p className="remind">
        <FormattedMessage id={fields[status].description} />
      </p>
        : null}
      {error
        ? (
          <p className="error-description">
            <FormattedMessage id={error} />
          </p>
          )
        : null}
      {canRetry && (
        <button className="filled" type="submit" disabled={code === ''}>
          <FormattedMessage id="continue" />
        </button>
      )}
      <span className="back" onClick={() => handleStatus('idle')} role="button">
        <FormattedMessage id="comeback" />
      </span>
    </form>
  )
}
